import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { AcrReportApi } from '../../shared/nestjs/gd-only/services/acr-report.api';
import { LoopBackAuth } from "../../shared/sdk";
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { ViewAttReportApi } from './../../shared/sdk/services/custom/ViewAttReport';
@Injectable()
export class AcrReportBloc {
    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private acrReportApi: AcrReportApi,
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        private viewattreportApi: ViewAttReportApi,
        private analyticsProvider: AnalyticsProvider
    ) { }


    downloadExcel(data: any): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.acrReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            console.log(data);
            resolve('Download Success')
        })
    }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Attendance Correction Report')
        } else {
            saveAs(data, 'Attendance Correction Report.xlsx')
        }
    }

    downloadPdf(data: any): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.acrReportApi.downloadPdf(data);
    }

    generatePdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            console.log(data);
            resolve('Download Success')
        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Attendance Correction Report')
        } else {
            saveAs(data, 'Attendance Correction Report.pdf')
        }
    }

    sendExcel(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.acrReportApi.sendMailExcel(data)
                } else {
                    data.sendEmail = true;
                    return this.viewattreportApi.download(data);
                }
            })
    }

    sendPdf(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.acrReportApi.sendMailPdf(data)
                } else {
                    data.sendEmail = true;
                    return this.viewattreportApi.pdfmake(data);
                }
            })
    }

    generatePreview(data): Observable<any> {
        return this.viewattreportApi.pdf2img(data);
    }

    correctionStatus(): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.acrReportApi.correctionStatus()
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/bloc/report/acr-report.bloc.ts